import DialogAssignee from "components/common/dialogsV6/DialogAssignee";
import { TreeDataNode } from "components/common/interfaces/OrgData";
import { Modal } from "components/Modal";

interface IProps {
  onClose: () => void;
  onResult: (data: TreeDataNode[]) => void;
}

const AddUserPopup = ({ onClose, onResult }: IProps) => {
  return (
    <Modal isOpen={true}>
      <div className="dark">
        <DialogAssignee isOpen={true} setIsOpen={onClose} onResult={onResult} />
      </div>
    </Modal>
  );
};

export default AddUserPopup;
